// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".study-reviews__versions-button[data-v-1481989c]{margin-right:var(--spacer)!important}.study-reviews__show-events-switch[data-v-1481989c] .switch-label{font-size:14px;line-height:20px;letter-spacing:.25px;color:var(--v-gray-light)}.study-reviews__show-events-switch[data-v-1481989c] .v-input .v-input--switch__track.theme--light{color:var(--v-gray-light)!important;opacity:1}", ""]);
// Exports
module.exports = exports;
